import { injectable } from 'inversify';
import type { IRealtimeEventService, EventHandler } from '@/service/RealTimeEvents/RealTimeEventService';
import { RealTimeEventService } from '@/service/RealTimeEvents/RealTimeEventService';
import type { ILocalControllerConnection } from '@/models/ILocalControllerConnection';
import { RealTimeEventTypes } from '@/enums/RealTimeEventTypes';
import type { ILocalControllerConfigurationAppliedMessage } from '@/models/Configuration/ILocalControllerConfigurationAppliedMessage';
import type { ILoadBalancingStatusMessage } from '@/models/LoadBalancing/ILoadBalancingStatusMessage';

export interface ILocalControllerRealTimeEventService extends IRealtimeEventService {};

@injectable()
export class LocalControllerRealTimeEventService extends RealTimeEventService implements ILocalControllerRealTimeEventService {
  
  constructor(hub: string) {
    super(hub);
  }

  buildConnection() {
    super.buildConnection()
    this.connection.on('LocalControllerConnectionStatusChangedEventAsync', this.onLocalControllerConnectionStatusesChangeEvent.bind(this));
    this.connection.on('LocalControllerConfigurationApplyStatusChangedEventAsync', this.onLocalControllerConfigurationApplyStatusChangedEvent.bind(this));
    this.connection.on('LoadBalancingStatusChangedEventAsync', this.onLoadBalancingStatusChangedEvent.bind(this));
}

  async onLocalControllerConnectionStatusesChangeEvent(connection: ILocalControllerConnection): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.LocalControllerConnectionStatusChangedEvent)
      .forEach(async (eventhandler: EventHandler<ILocalControllerConnection>) => {
        await eventhandler.handle(connection);
      })
  }

  async onLocalControllerConfigurationApplyStatusChangedEvent(applyMessage: ILocalControllerConfigurationAppliedMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.LocalControllerConfigurationAppliedEvent)
      .forEach(async (eventHandler: EventHandler<ILocalControllerConfigurationAppliedMessage>) => {
        await eventHandler.handle(applyMessage);
      });
  }

  async onLoadBalancingStatusChangedEvent(loadBalancingMessage: ILoadBalancingStatusMessage) : Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.LoadBalancingStatusChangedEvent)
      .forEach(async (eventHandler: EventHandler<ILoadBalancingStatusMessage>) => {
        await eventHandler.handle(loadBalancingMessage);
      })
  }
}